import {
  projectIdentityAtIngress,
  providerFromStorageKey,
  qualifyProjectStorageKey,
  type ProjectIdentity as StructuredProjectIdentity,
  type ProjectProvider,
} from "../../../shared/projectIdentity";

export type { ProjectProvider, StructuredProjectIdentity };

export type ProjectIdentity = StructuredProjectIdentity & { projectPath: string };

export function providerFromProjectPath(path: string | null | undefined): ProjectProvider | null {
  return providerFromStorageKey(path);
}

export function displayProjectPath(
  scopedPath: string | null | undefined,
  provider?: ProjectProvider | string | null,
  instanceUrl?: string | null
): string {
  return (
    projectIdentityAtIngress(scopedPath, {
      provider: provider ?? providerFromStorageKey(scopedPath),
      instanceUrl,
    })?.namespacePath ??
    scopedPath?.trim() ??
    ""
  );
}

export function qualifyProjectPath(
  provider: ProjectProvider | string | null | undefined,
  path: string | null | undefined,
  instanceUrl?: string | null
): string {
  return qualifyProjectStorageKey(provider, path, instanceUrl);
}

export function parseProjectIdentity(
  path: string | null | undefined,
  fallbackProvider?: ProjectProvider | string | null,
  instanceUrl?: string | null
): ProjectIdentity | null {
  const identity = projectIdentityAtIngress(path, {
    provider: providerFromProjectPath(path) ?? fallbackProvider,
    instanceUrl,
  });
  return identity ? { ...identity, projectPath: identity.namespacePath } : null;
}

export function isProjectPathCompatibleWithProvider(
  path: string,
  provider: ProjectProvider | string | null | undefined
): boolean {
  const pathProvider = providerFromProjectPath(path);
  return !pathProvider || !provider || pathProvider === provider;
}
